import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryDropdown from './components/CategoryDropdown';
import TrustBadges from './components/TrustBadges';
import FeatureComparison from './components/FeatureComparison';
import ProductCategories from './components/ProductCategories';
import ArticleCards from './components/ArticleCards';
import SEOContent from './components/SEOContent';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <CategoryDropdown />
      <TrustBadges />
      <FeatureComparison />
      <ProductCategories />
      <ArticleCards />
      <SEOContent />

      <section className="py-14 md:py-20 bg-background-100">
        <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
          <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">
            Managing Data Is Difficult Without The Right Spreadsheet System
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8 text-left max-w-2xl mx-auto">
            <div className="flex items-start gap-3 p-4 bg-background-50 rounded-xl border border-background-200/50">
              <span className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mt-0.5">
                <i className="ri-close-line text-sm"></i>
              </span>
              <p className="text-sm text-foreground-700">Complicated data organization across multiple platforms</p>
            </div>
            <div className="flex items-start gap-3 p-4 bg-background-50 rounded-xl border border-background-200/50">
              <span className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mt-0.5">
                <i className="ri-close-line text-sm"></i>
              </span>
              <p className="text-sm text-foreground-700">Time-consuming manual reports that slow down workflows</p>
            </div>
            <div className="flex items-start gap-3 p-4 bg-background-50 rounded-xl border border-background-200/50">
              <span className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mt-0.5">
                <i className="ri-close-line text-sm"></i>
              </span>
              <p className="text-sm text-foreground-700">Difficult tracking systems that lack proper integration</p>
            </div>
            <div className="flex items-start gap-3 p-4 bg-background-50 rounded-xl border border-background-200/50">
              <span className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mt-0.5">
                <i className="ri-close-line text-sm"></i>
              </span>
              <p className="text-sm text-foreground-700">Lack of automation that reduces overall team efficiency</p>
            </div>
          </div>
          <p className="mt-6 text-sm text-primary-700 font-semibold">
            Vigorbuy Spreadsheet provides structured solutions for modern data management.
          </p>
        </div>
      </section>

      <Footer />
    </main>
  );
}